import React from 'react'

export const LockIcon = ({ mode = "" }) => {

    const modes = {
        active: <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            fill="none"
            viewBox="0 0 12 12">
            <path
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.458"
                d="M9.5 5.5h-7a1 1 0 00-1 1V10a1 1 0 001 1h7a1 1 0 001-1V6.5a1 1 0 00-1-1zM3.5 5.5v-2a2.5 2.5 0 115 0v2"
            ></path>
        </svg>,
        inactive: <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            fill="none"
            viewBox="0 0 12 12"
        >
            <path
                stroke="#A6B7F7"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.458"
                d="M9.5 5.5h-7a1 1 0 00-1 1V10a1 1 0 001 1h7a1 1 0 001-1V6.5a1 1 0 00-1-1zM3.5 5.5v-2a2.5 2.5 0 115 0v2"
            ></path>
        </svg>
    }
    return (
        <div>
            {modes?.[mode] || ''}
        </div>
    )
}

export const HelpIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="39"
        height="39"
        fill="none"
        viewBox="0 0 40 40"
        {...props}
    >
        <circle cx="20" cy="20" r="19.5" fill="#5473E3" stroke="#3753B8"></circle>
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 14.438a5.146 5.146 0 0110 1.716c0 3.43-5.146 5.145-5.146 5.145M19.99 28.16h.017"
        ></path>
    </svg>
)

export const ExternalLinkIcon = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
>
    <path
        stroke="#5473E3"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 10.833v5a1.666 1.666 0 01-1.667 1.667H4.167A1.667 1.667 0 012.5 15.833V6.667A1.667 1.667 0 014.167 5h5M12.5 2.5h5v5M8.334 11.667L17.5 2.5"
    ></path>
</svg>)

export const CircleIcon = (props) => (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" {...props}>
    <circle cx="8" cy="8" r="7" fill="red"   {...props}></circle>
</svg>)

export const KeyboardRightIcon = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24" {...props}
>
    <path
        stroke="#394657"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 12h14M12 5l7 7-7 7"
    ></path>
</svg>)

export const WhiteBreifCaseIcon = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
>
    <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 5.25H3a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h12a1.5 1.5 0 001.5-1.5v-7.5a1.5 1.5 0 00-1.5-1.5z"
    ></path>
    <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 15.75v-12a1.5 1.5 0 00-1.5-1.5h-3A1.5 1.5 0 006 3.75v12"
    ></path>
</svg>)

export const PDFIcon2 = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"  {...props}
>
    <path
        stroke="#394657"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.875 3H6.75c-.464 0-.91.19-1.237.527A1.826 1.826 0 005 4.8v14.4c0 .477.184.935.513 1.273.328.337.773.527 1.237.527h10.5c.464 0 .91-.19 1.237-.527.329-.338.513-.796.513-1.273V9.3L12.875 3z"
    ></path>
    <path
        stroke="#394657"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 3v6h6"
    ></path>
    <path
        fill="#394657"
        fillRule="evenodd"
        d="M13.35 14.578c-.39-.434-.774-.919-1.12-1.355l-.008-.01a48.103 48.103 0 00-.468-.585l-.011-.013c.215-.613.338-1.116.366-1.493.07-.96-.038-1.579-.328-1.89a.721.721 0 00-.767-.192c-.198.066-.467.244-.62.715-.23.7-.118 1.943.532 2.97a21.93 21.93 0 01-1.142 2.465c-.85.298-1.53.69-2.016 1.166-.636.621-.895 1.237-.71 1.69.114.281.378.449.705.449.228 0 .475-.082.713-.238.602-.394 1.389-1.705 1.81-2.466a11.226 11.226 0 012.173-.426c.198-.02.395-.034.584-.045.767.81 1.394 1.236 1.971 1.343.116.021.233.032.346.032.47 0 .86-.187 1.041-.502a.744.744 0 00-.008-.76c-.32-.555-1.287-.86-2.723-.86-.103 0-.21.001-.32.005zm-5.273 3.069a.643.643 0 01-.314.119.14.14 0 01-.032-.004c-.015-.072.037-.387.546-.884a3.85 3.85 0 01.9-.636c-.452.727-.858 1.247-1.1 1.405zm3.17-7.916c-.042.014-.107.087-.16.25-.147.45-.08 1.146.163 1.772a3.72 3.72 0 00.132-.683c.075-1.04-.093-1.295-.133-1.34h-.001l-.002.001zm1.142 4.909a12.39 12.39 0 00-1.638.27c.255-.51.492-1.028.69-1.507l.21.264.01.012c.235.297.5.63.774.957l-.046.004zm3.38 1.189c.003-.005.003-.013-.008-.031-.091-.159-.55-.432-1.685-.487.418.371.77.58 1.07.635.074.014.146.02.213.02.241 0 .38-.084.41-.137z"
        clipRule="evenodd"
    ></path>
</svg>)

export const CheckIcon = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
>
    <path
        stroke="#394657"
        {...props}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.667 5L7.5 14.167 3.333 10"
    ></path>
</svg>)

export const OverviewIcon = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
>
    <path
        stroke="#394657"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.675 13.242A8.335 8.335 0 116.667 2.358M17.699 6.811a8.333 8.333 0 01.634 3.19H10V1.666a8.333 8.333 0 017.699 5.144z"
    ></path>
</svg>)

export const CopyIcon = () => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
>
    <g
        stroke="#5473E3"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#clip0_183_1344)"
    >
        <path d="M11.667 5.25h-5.25c-.645 0-1.167.522-1.167 1.167v5.25c0 .644.522 1.166 1.167 1.166h5.25c.644 0 1.166-.522 1.166-1.166v-5.25c0-.645-.522-1.167-1.166-1.167z"></path>
        <path d="M2.917 8.75h-.584a1.167 1.167 0 01-1.166-1.167v-5.25a1.167 1.167 0 011.166-1.166h5.25A1.167 1.167 0 018.75 2.333v.584"></path>
    </g>
    <defs>
        <clipPath id="clip0_183_1344">
            <path fill="#fff" d="M0 0H14V14H0z"></path>
        </clipPath>
    </defs>
</svg>)

export const UserCheckIcon = () => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
>
    <path
        stroke="#7D96F0"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.333 17.5v-1.667A3.333 3.333 0 0010 12.5H4.167a3.333 3.333 0 00-3.334 3.333V17.5M7.083 9.167a3.333 3.333 0 100-6.667 3.333 3.333 0 000 6.667zM14.167 9.167l1.666 1.666L19.167 7.5"
    ></path>
</svg>)

export const UserCheckIconwhite = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24" {...props}
>
    <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M8.5 11a4 4 0 100-8 4 4 0 000 8zM17 11l2 2 4-4"
    ></path>
</svg>)

export const LoginBlackIcon = (props) => {
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24" {...props}
    >
        <path
            stroke="#394657"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M15 12H3"
        ></path>
    </svg>
    )
}

export const BreifCaseIconWhite = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    {...props}>
    <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 5.25H3a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h12a1.5 1.5 0 001.5-1.5v-7.5a1.5 1.5 0 00-1.5-1.5z"
        {...props}
    ></path>
    <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 15.75v-12a1.5 1.5 0 00-1.5-1.5h-3A1.5 1.5 0 006 3.75v12"
        {...props}
    ></path>
</svg>)

export const MaximizeWhiteIcon = () => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
>
    <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.333 2h-2A1.333 1.333 0 002 3.333v2m12 0v-2A1.334 1.334 0 0012.667 2h-2m0 12h2A1.334 1.334 0 0014 12.667v-2m-12 0v2A1.333 1.333 0 003.333 14h2"
    ></path>
</svg>)

export const IconRightTop = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
>
    <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.667 6L10 2.667 13.333 6"
    ></path>
    <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.667 13.333h4.666A2.667 2.667 0 0010 10.666v-8"
    ></path>
</svg>)

export const MaximizeIcon = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16" {...props}
>
    <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 2h4v4M6 14H2v-4M14 2L9.333 6.667M2 14l4.667-4.666"
    ></path>
</svg>)

export const BookIcon = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-book"
    viewBox="0 0 24 24"
>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2"></path>
</svg>)

export const UnlockIcon = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
>
    <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.667 7.334H3.333C2.597 7.334 2 7.93 2 8.667v4.667c0 .736.597 1.333 1.333 1.333h9.334c.736 0 1.333-.597 1.333-1.333V8.667c0-.737-.597-1.333-1.333-1.333M4.667 7.333V4.667a3.333 3.333 0 0 1 6.6-.667"
    ></path>
</svg>)

export const LayerIcon = (props) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-layers"
    viewBox="0 0 24 24"
    {...props}
>
    <path d="M12 2 2 7l10 5 10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
</svg>)

export const CardIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        stroke="#677A8E"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-credit-card"
        viewBox="0 0 24 24" {...props}
    >
        <rect width="22" height="16" x="1" y="4" rx="2" ry="2"></rect>
        <path d="M1 10h22"></path>
    </svg>
);

export const ActivityIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.333 4 6 11.333 2.667 8"
      ></path>
    </svg>
  );
export const ClockIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        {...props}
    >
        <g
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            clipPath="url(#clip0_1007_490)"
        >
            <path d="M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333"></path>
            <path d="M8 4v4l2.667 1.333"></path>
        </g>
        <defs>
            <clipPath id="clip0_1007_490">
                <path fill="#fff" d="M0 0h16v16H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

export const DBIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16" {...props}
    >
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 5.334c3.314 0 6-.896 6-2s-2.686-2-6-2-6 .895-6 2 2.686 2 6 2M14 8c0 1.107-2.667 2-6 2s-6-.893-6-2"
        ></path>
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2 3.334v9.333c0 1.107 2.667 2 6 2s6-.893 6-2V3.334"
        ></path>
    </svg>
);
 
export const CPUIcon = (props) => (<svg 
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-cpu"
    viewBox="0 0 24 24" {...props}
>
    <rect width="16" height="16" x="4" y="4" rx="2" ry="2"></rect>
    <path d="M9 9h6v6H9zM9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3"></path>
</svg>)

 
export const DollarIcon = (props) => (<svg 
    xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
   
      className="feather feather-dollar-sign"
      viewBox="0 0 24 24"
      {...props}
  >
      <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
  </svg>)
 


export const TableCollapseIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            stroke="#394657"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m18 9-6 6-6-6"
        ></path>
    </svg>
);

export const LoginIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        fill="none"
        viewBox="0 0 25 24"
        {...props}
    >
        <path
            stroke="#5473E3"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.5 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10.5 17l5-5-5-5M15.5 12h-12"
        ></path>
    </svg>
);


export const CalendarIcon2 = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
     
      fill="none"
     
      {...props}
    >
      <path
        stroke="#A3B3C8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.667 2.666H3.333C2.597 2.666 2 3.263 2 3.999v9.334c0 .736.597 1.333 1.333 1.333h9.334c.736 0 1.333-.597 1.333-1.333V3.999c0-.736-.597-1.333-1.333-1.333M10.667 1.334v2.667M5.333 1.334v2.667M2 6.666h12"
      ></path>
    </svg>
  );